<template>
  <div class="App">
    <section class="section1">
      <svg
        class="img"
        width="598.38259"
        height="519.36575"
        viewBox="0 0 598.38259 519.36575"
      >
        <path
          d="M854.37384,671.40435l16.11882-5.113a54.56124,54.56124,0,0,0-.38831-26.249c-6.47575,14.3987-25.47463,17.92647-36.29963,29.419a32.81871,32.81871,0,0,0-8.3953,27.17926l-3.39124,11.504a54.99381,54.99381,0,0,0,40.024-22.76717,53.12122,53.12122,0,0,0,6.22435-11.78347C861.39249,672.90577,854.37384,671.40435,854.37384,671.40435Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#f2f2f2"
        />
        <path
          d="M837.14986,650.13183l12.14673-11.765A54.56128,54.56128,0,0,0,837.24247,615.046c.62547,15.7755-14.806,27.40615-19.36941,42.52016a32.81867,32.81867,0,0,0,4.60727,28.07073l2.09524,11.809A54.99378,54.99378,0,0,0,850.245,659.2183a53.12068,53.12068,0,0,0,.31586-13.32264C844.10146,648.34548,837.14986,650.13183,837.14986,650.13183Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#f2f2f2"
        />
        <path
          d="M756.405,224.54359H302.112a1.807,1.807,0,0,1,0-3.61319H756.405a1.807,1.807,0,0,1,0,3.61319Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <ellipse
          cx="32.69152"
          cy="10.82345"
          rx="10.58751"
          ry="10.82345"
          fill="#3f3d56"
        />
        <ellipse
          cx="69.26654"
          cy="10.82345"
          rx="10.58751"
          ry="10.82345"
          fill="#3f3d56"
        />
        <ellipse
          cx="105.84156"
          cy="10.82345"
          rx="10.58751"
          ry="10.82345"
          fill="#3f3d56"
        />
        <path
          d="M734.38374,192.74209h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <path
          d="M734.38374,200.12647h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <path
          d="M734.38374,207.50114h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <circle cx="35.19338" cy="94.79521" r="13.08937" fill="#e6e7e8" />
        <path
          d="M668.86084,313.839H326.34674a3.89775,3.89775,0,1,1,0-7.7955h342.5141a3.89775,3.89775,0,1,1,0,7.7955Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <path
          d="M579.03041,329.241H326.34674a3.89794,3.89794,0,0,1,0-7.79588H579.03041a3.89794,3.89794,0,1,1,0,7.79588Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <circle cx="35.19338" cy="299.09983" r="13.08937" fill="#e6e7e8" />
        <path
          d="M668.86084,518.14363H326.34674a3.89775,3.89775,0,1,1,0-7.79549h342.5141a4.35939,4.35939,0,0,1,4.11419,4.19844A3.84941,3.84941,0,0,1,668.86084,518.14363Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <path
          d="M579.03041,533.54558H326.34674a3.89794,3.89794,0,0,1,0-7.79588H579.03041a3.89794,3.89794,0,1,1,0,7.79588Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <circle cx="35.19338" cy="189.24655" r="13.08937" fill="#e6e7e8" />
        <path
          d="M668.86084,408.29035H326.34674a3.89775,3.89775,0,1,1,0-7.7955h342.5141a3.89775,3.89775,0,1,1,0,7.7955Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <path
          d="M621.16327,423.6923H326.34674a3.89794,3.89794,0,0,1,0-7.79588H621.16327a3.89794,3.89794,0,0,1,0,7.79588Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <path
          d="M601.15322,439.09425H326.34674a3.89794,3.89794,0,0,1,0-7.79588H601.15322a3.89794,3.89794,0,1,1,0,7.79588Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#e6e7e8"
        />
        <circle
          cx="306.49461"
          cy="324.42079"
          r="96.9336"
          fill="#4580F7"
          class="theme-fill"
        />
        <circle cx="306.36146" cy="344.39338" r="13.84766" fill="#3f3d56" />
        <circle
          cx="306.36146"
          cy="344.39338"
          r="6.39123"
          fill="#4580F7"
          class="theme-fill"
        />
        <path
          d="M632.41156,565.278h-51.144a19.12258,19.12258,0,0,1-19.10157-19.10059V522.72822a19.12342,19.12342,0,0,1,19.10157-19.10156h51.144a19.12331,19.12331,0,0,1,19.10107,19.10156v23.44922A19.12247,19.12247,0,0,1,632.41156,565.278Zm-51.144-59.65137a17.12113,17.12113,0,0,0-17.10157,17.10156v23.44922A17.12029,17.12029,0,0,0,581.26752,563.278h51.144a17.11986,17.11986,0,0,0,17.10107-17.10059V522.72822a17.1207,17.1207,0,0,0-17.10107-17.10156Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#fff"
        />
        <path
          d="M578.23849,552.5493h45.39544a17.94254,17.94254,0,0,0,17.94256-17.94256V514.98319a17.86278,17.86278,0,0,0-1.18355-6.36529,17.895,17.895,0,0,1,7.13091,14.2951v19.62355a17.94254,17.94254,0,0,1-17.94257,17.94256H584.18585a17.93276,17.93276,0,0,1-16.759-11.57727A17.83961,17.83961,0,0,0,578.23849,552.5493Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <polygon
          points="416.909 506.542 405.755 506.541 400.448 463.514 416.912 463.515 416.909 506.542"
          fill="#a0616a"
        />
        <path
          d="M717.64736,708.23783l-34.30291-.0013v-.43381a13.35238,13.35238,0,0,1,13.35164-13.35144h.00083l6.26586-4.75361,11.69073,4.75434,2.99442.0001Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <polygon
          points="495.838 506.542 506.993 506.541 512.3 463.514 495.836 463.515 495.838 506.542"
          fill="#a0616a"
        />
        <path
          d="M795.79,708.23783l34.3029-.0013v-.43381a13.35238,13.35238,0,0,0-13.35164-13.35144h-.00083l-6.26586-4.75361L798.78385,694.452l-2.99442.0001Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <path
          d="M700.302,621.95549c.16474-2.45511,1.47464-16.03273,1.47464-16.03273l3.13752-28.79462,5.52988-76.32805.36083-4.9965,28.96716-5.56128,19.79775-9.491,23.53141,7.52223,18.32311,6.87118s.03136,2.94142.17254,6.49469c.18825,4.65142.51767,10.35383,1.30205,11.83632,1.30991,2.61985.98048,16.68379.98048,16.68379s1.30205,28.61417,2.94143,31.7517,1.96875,9.67142,1.47464,10.98132,1.63937,35.6736,1.63937,35.6736,5.4758,60.811,2.04021,69.98042-16.41791,3.163-16.41791,3.163.62749-2.44726-3.13753-3.60033-15.2327-87.38-15.2327-87.38-2.13349-17.68-4.09444-22.747-3.765-19.30358-3.765-19.30358-12.11084-23.56282-12.26772-28.80248c0,0-1.58447-4.90237-3.08261.49417s-5.91421,18.32311-5.91421,18.32311l-4.30624,15.8758L738.68954,578.289l-3.2787,19.97034s-4.91023,26.50419-5.69461,27.6494,0,25.359,0,25.359-3.79638,20.62135-9.16156,24.22167-19.57964.05718-19.57964.05718S700.13728,624.41061,700.302,621.95549Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <polygon
          points="412.315 236.13 418.755 255.528 410.809 264.987 414.308 268.588 411.727 273.678 404.997 327.032 441.894 341.025 454.319 325.447 464.116 341.025 506.81 330.593 495.922 262.556 495.922 258.108 492.848 249.519 492.848 231.337 500.966 177.215 476.736 168.728 465.151 159.559 461.402 172.454 445.44 169.615 445.024 159.927 432.811 171.466 422.527 174.399 410.213 177.215 408.644 181.137 411.781 180.353 411.272 231.377 412.315 236.13"
          fill="#2f2e41"
        />
        <path
          d="M701.63112,497.16362l6.19682-59.98181,1.63562-24.68654L692.11883,409.359s.68726,17.65162-1.58492,27.61085c-2.24226,9.82765-.29746,58.87688-.15891,60.18842a8.4387,8.4387,0,1,0,11.25612.00535Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#a0616a"
        />
        <path
          d="M684.71257,449.61094l4.82391.99618,16.55046,3.42774.91771.18824,1.9531-7.76533,2.26687-2.41591,4.31409-22.60584.22745-1.17657,6.5182-13.93061,4.50971-41.87022-16.77006,3.012c-.08627.08627-.16474.18039-.24315.27451-2.40806,2.72963-4.12585,6.52605-6.93395,10.346-9.138,12.43246-16.14988,42.6389-15.87532,59.18936.00785.26666-.26671.55688-.59614.855A9.18008,9.18008,0,0,0,684.71257,449.61094Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <path
          d="M809.45309,497.16362l-6.19682-59.98181-1.63562-24.68654,17.34473-3.13627s-.68726,17.65162,1.58492,27.61085c2.24226,9.82765.29746,58.87688.15891,60.18842a8.43869,8.43869,0,1,1-11.25612.00535Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#a0616a"
        />
        <path
          d="M826.37164,449.61094l-4.82391.99618-16.55045,3.42774-.91772.18824-1.95309-7.76533-2.26688-2.41591L795.5455,421.436l-.22745-1.17657-6.5182-13.93061,1.4903-41.87022,10.77,3.012c.08627.08627.16474.18039.24316.27451,2.40805,2.72963,4.12584,6.52605,6.93394,10.346,9.138,12.43246,16.14988,42.6389,15.87532,59.18936-.00785.26666.26671.55688.59614.855A9.18008,9.18008,0,0,1,826.37164,449.61094Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <path
          d="M737.489,370.65369l7.87971-20.6669,20.12717-.36864,6.67878,21.03554,24.0059,134.1036s-73.54408,20.48067-72.79806-4.13807c.78438-25.88455,4.32336-60.26788,4.32336-60.26788Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#4580F7"
          class="theme-fill"
        />
        <circle cx="454.63748" cy="130.43677" r="23.70998" fill="#a0616a" />
        <path
          d="M729.87412,303.296c3.86011-4.2014,8.68826-11.892,23.31228-15.12147,18.07034-3.99055,26.60919,12.33362,22.05218,12.6012,13.32515,4.03514,4.76529,31.6106.94512,29.29792A1.12494,1.12494,0,0,1,776.08928,330,18.77,18.77,0,0,1,768.592,317.1934l-.725-6.52543c-.10351,5.30926-5.53035,6.01158-11.07409,4.05623a6.95535,6.95535,0,0,1,4.91385-4.83821,23.78593,23.78593,0,0,1-13.97147,6.07912,9.51087,9.51087,0,0,1,4.62511-6.36419l-.2188-.215a22.84961,22.84961,0,0,1-7.33,4.1504c-3.056.87594-6.71782.40207-8.81164-1.99015a6.50041,6.50041,0,0,1-1.25249-2.25409c.45268,4.2047-2.36752,9.00438-4.55825,8.18032C728.36675,317.11823,727.30441,306.0929,729.87412,303.296Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#2f2e41"
        />
        <path
          d="M898.72738,708.23514a1.18647,1.18647,0,0,1-1.19006,1.19h-280.29a1.19,1.19,0,0,1,0-2.38h280.29A1.18651,1.18651,0,0,1,898.72738,708.23514Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#ccc"
        />
        <path
          d="M607.62666,461.92192c-9.48085,0-17.81459,4.29206-22.5331,10.73464a29.12131,29.12131,0,0,1,17.37286-5.5744c14.68157,0,26.626,10.28436,26.626,22.92543v10.50777h5.16024v-15.668C634.25262,472.20628,622.30823,461.92192,607.62666,461.92192Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#3f3d56"
        />
        <path
          d="M637.79828,505.89326h-61.918V487.67549c0-14.69824,13.88818-26.65625,30.959-26.65625s30.959,11.958,30.959,26.65625Zm-59.918-2h57.918V487.67549c0-13.5957-12.99073-24.65625-28.959-24.65625s-28.959,11.06055-28.959,24.65625Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#fff"
        />
        <path
          d="M622.69671,498.93818H590.98187a5.38755,5.38755,0,0,1-5.38135-5.38183v-7.25c0-10.1084,9.52783-18.332,21.23877-18.332s21.23877,8.22363,21.23877,18.332v7.25A5.38754,5.38754,0,0,1,622.69671,498.93818Zm-15.85742-28.96386c-10.6084,0-19.23877,7.32617-19.23877,16.332v7.25a3.38525,3.38525,0,0,0,3.38135,3.38183h31.71484a3.38525,3.38525,0,0,0,3.38135-3.38183v-7.25C626.07806,477.30049,617.44769,469.97432,606.83929,469.97432Z"
          transform="translate(-300.34479 -190.05939)"
          fill="#fff"
        />
      </svg>
      <div class="content">
        <p
          class="d-flex align-items-center"
          style="column-gap: 0.5rem; font-size: 14px"
        >
          <i class="far fa-eye-slash fa-1-5x" /><span class="theme-color">{{
            $t("martinelli.hero.badge")
          }}</span>
        </p>
        <h1>
          {{ $t("martinelli.hero.title") }}
          <small>{{ $t("martinelli.hero.titleSmall") }}</small>
        </h1>
        <p class="text-darkgray">
          {{ $t("martinelli.hero.description", [company.name]) }}
        </p>
        <div class="buttons">
          <b-button variant="primary" :to="'/' + Routes['report'][$i18n.locale]"
            >{{ $t("martinelli.hero.reportBtn") }}
          </b-button>
          <b-button
            v-if="hasDocumentsSection"
            variant="link"
            href="#leiturasImportantes"
            class="theme-color"
            >{{ $t("martinelli.hero.howItWorks") }}
            <i class="fas fa-arrow-right fa-1-5x"
          /></b-button>
        </div>
      </div>
    </section>
    <section id="consultar" class="section2">
      <div>
        <div class="content">
          <span class="theme-color title">{{
            $t("martinelli.followUp.badge")
          }}</span>
          <h1>
            {{ $t("martinelli.followUp.title") }}
          </h1>
        </div>
        <div class="form">
          <b-input-group class="protocol-input">
            <b-input
              v-model="protocol"
              :placeholder="$t('martinelli.followUp.placeholder')"
            ></b-input>
            <b-button
              variant="primary"
              :to="`/${Routes['follow-up'][$i18n.locale]}/${protocol}`"
              >{{ $t("martinelli.followUp.searchBtn") }}</b-button
            >
          </b-input-group>
        </div>
      </div>
    </section>
    <section id="organizacao" class="section3">
      <div class="content">
        <h1>
          {{ $t("martinelli.organization.titleEnd") }}
          <small>{{ $t("martinelli.organization.titleHighlight") }}</small>
        </h1>
        <p>
          {{ $t("martinelli.organization.description") }}
        </p>
      </div>
      <div class="key-features">
        <div class="feature">
          <i class="fa fa-user-lock" />
          <h3>{{ $t("martinelli.features.confidentiality.title") }}</h3>
          <p>
            {{ $t("martinelli.features.confidentiality.desc") }}
          </p>
        </div>
        <div class="feature">
          <i class="fa fa-user-shield" />
          <h3>{{ $t("martinelli.features.nonRetaliation.title") }}</h3>
          <p>
            {{ $t("martinelli.features.nonRetaliation.desc") }}
          </p>
        </div>
        <div class="feature">
          <i class="fa fa-list-check" />
          <h3>{{ $t("martinelli.features.tracking.title") }}</h3>
          <p>
            {{ $t("martinelli.features.tracking.desc") }}
          </p>
        </div>
        <div class="feature">
          <i class="fa fa-comment-dots" />
          <h3>{{ $t("martinelli.features.feedback.title") }}</h3>
          <p>
            {{ $t("martinelli.features.feedback.desc") }}
          </p>
        </div>
      </div>
    </section>
    <section id="funcionamento" class="section4">
      <div class="content">
        <h1>
          {{ $t("martinelli.process.title")
          }}<small> {{ $t("martinelli.process.titleSmall") }}</small
          >{{ $t("martinelli.process.titleEnd") }}
        </h1>
        <p>
          {{ $t("martinelli.process.description") }}
        </p>
      </div>
      <svg
        class="img"
        width="967.97244"
        height="529"
        viewBox="0 0 967.97244 529"
        role="img"
      >
        <path
          d="M154.44233,692.271c26.42252,19.03478,60.66413,19.99056,93.76235,17.65213,4.62174-.32609,9.21077-.70874,13.75729-1.12157.02746-.00712.06353-.00458.09143-.01167.2185-.0208.43744-.04161.6465-.054.93841-.08779,1.87724-.1755,2.80685-.26387l-.2196.419-.68925,1.30024c.2477-.43517.49521-.86129.74291-1.29646.07285-.13062.15451-.26067.22693-.39138,8.57426-14.92076,17.07842-30.38965,19.24765-47.4275,2.24221-17.68452-4.05929-37.70924-19.62367-46.40124a31.40808,31.40808,0,0,0-6.4449-2.69923c-.93085-.28285-1.8743-.51228-2.82845-.71534A33.66447,33.66447,0,0,0,216.76908,655.022c-13.19581-13.53109-10.73425-35.482-6.18233-53.82747,4.56073-18.34493,10.08188-38.7585.80579-55.236-5.15643-9.17155-14.2243-14.86189-24.40066-17.15421-.31218-.06731-.62393-.13454-.93675-.19277a49.13015,49.13015,0,0,0-35.29737,6.1847c-19.45809,12.26176-29.452,35.51036-32.69561,58.28426C112.8361,629.72786,124.40143,670.62755,154.44233,692.271Z"
          transform="translate(-116.01378 -185.5)"
          fill="#f1f1f1"
        />
        <path
          d="M162.97318,633.5239a83.51853,83.51853,0,0,0,5.76411,23.53543A72.52018,72.52018,0,0,0,179.99707,675.451c9.49657,11.42369,22.05367,20.01238,35.691,25.73513a133.7282,133.7282,0,0,0,32.51657,8.737c4.62174-.32609,9.21077-.70874,13.75729-1.12157.02746-.00712.06353-.00458.09143-.01167.2185-.0208.43744-.04161.6465-.054.93841-.08779,1.87724-.1755,2.80685-.26387l-.2196.419-.68925,1.30024c.2477-.43517.49521-.86129.74291-1.29646.07285-.13062.15451-.26067.22693-.39138a73.92225,73.92225,0,0,1-20.71723-64.6648,74.55543,74.55543,0,0,1,13.89631-31.86317c-.93085-.28285-1.8743-.51228-2.82845-.71534a77.3,77.3,0,0,0-7.0511,11.67872,75.7417,75.7417,0,0,0-6.53473,47.11952,77.43753,77.43753,0,0,0,19.61965,38.62482c-.88275-.06222-1.77409-.1341-2.64633-.21369-16.52166-1.39976-33.00967-4.9516-47.995-12.22685a86.44054,86.44054,0,0,1-32.382-26.57c-9.07565-12.51653-13.07481-27.5721-13.7618-42.87405-.72844-16.38207,1.39716-33.05187,5.13582-48.9833a205.59724,205.59724,0,0,1,17.27595-47.05958,1.47818,1.47818,0,0,0-.58694-1.95143,1.25724,1.25724,0,0,0-.93675-.19277,1.09451,1.09451,0,0,0-.72256.619c-.94456,1.8435-1.87153,3.68824-2.76326,5.55359a207.93123,207.93123,0,0,0-16.2775,48.82276C163.00752,599.89618,161.25452,616.93624,162.97318,633.5239Z"
          transform="translate(-116.01378 -185.5)"
          fill="#fff"
        />
        <path
          d="M498.01378,714.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z"
          transform="translate(-116.01378 -185.5)"
          fill="#cbcbcb"
        />
        <path
          d="M383.64443,445.9675,366.417,361.55189l-7.56774-62.3493-16.76577,10.846,2.31606,68.709,26.75976,71.18916a9.32773,9.32773,0,1,0,12.48513-3.97927Z"
          transform="translate(-116.01378 -185.5)"
          fill="#ffb7b7"
        />
        <path
          d="M222.51709,452.49467l4.76864-86.02349-1.5795-62.787,22.16477,8.29264,3.70019,68.31545-16.123,74.32382a9.32774,9.32774,0,1,1-12.93108-2.12139Z"
          transform="translate(-116.01378 -185.5)"
          fill="#ffb7b7"
        />
        <polygon
          points="152.925 517.096 164.25 517.095 169.638 473.411 152.923 473.412 152.925 517.096"
          fill="#ffb7b7"
        />
        <path
          d="M266.04945,698.89831l22.3041-.00091h.00091a14.2147,14.2147,0,0,1,14.21392,14.2137v.4619l-36.51825.00135Z"
          transform="translate(-116.01378 -185.5)"
          fill="#2f2e41"
        />
        <polygon
          points="195.822 512.084 207.014 513.815 219.018 471.469 202.5 468.914 195.822 512.084"
          fill="#ffb7b7"
        />
        <path
          d="M309.54612,693.48825l22.042,3.40954.00089.00014a14.2147,14.2147,0,0,1,11.87341,16.22l-.07063.45646-36.089-5.58254Z"
          transform="translate(-116.01378 -185.5)"
          fill="#2f2e41"
        />
        <path
          d="M265.61172,689.55283l-.0587-.31681L224.55262,467.5608a83.73918,83.73918,0,0,1,7.39968-52.36494l24.81587-49.63139,74.0481,10.03176,8.73894,63.18874,31.14228,120.5417-.03084.09813-39.9,126.74124-26.14988,1.72,23.164-113.13449-42.41449-96.33649L288.358,687.8293Z"
          transform="translate(-116.01378 -185.5)"
          fill="#2f2e41"
        />
        <path
          d="M332.54,383.683l-.48871-.76574c-.08779-.13808-9.08238-13.68946-33.55867-4.64142-24.98636,9.23833-44.34706-8.60472-44.53981-8.7859l-.09585-.09042-5.65862-50.43534-6.68-40.94362,21.264-3.73059,10.45424-6.27209,41.57111-.74016,10.93945,8.604,17.96045,1.95729,1.64416,37.307-.00754.04065Z"
          transform="translate(-116.01378 -185.5)"
          fill="#4580F7"
          class="theme-fill"
        />
        <path
          d="M338.49789,318.75458v-31.945l5.05057-9.21731.20537-.00631a15.14058,15.14058,0,0,1,10.46072,4.75287c5.08,5.1615,7.38128,13.761,6.84,25.55936l-.01.21588Z"
          transform="translate(-116.01378 -185.5)"
          fill="#4580F7"
          class="theme-fill"
        />
        <path
          d="M250.46647,315.28227,224.72452,312.193l-.02015-.29649c-.87824-12.8368,1.36239-22.36567,6.65951-28.32129,4.80754-5.40507,10.31616-5.73239,10.54834-5.74361l.14859-.007,6.96844,6.33482Z"
          transform="translate(-116.01378 -185.5)"
          fill="#4580F7"
          class="theme-fill"
        />
        <path
          d="M324.98425,254.40579h-67.7379a5.26145,5.26145,0,0,1-5.25552-5.25553V224.62447a39.12447,39.12447,0,0,1,78.24894,0v24.52579A5.26145,5.26145,0,0,1,324.98425,254.40579Z"
          transform="translate(-116.01378 -185.5)"
          fill="#2f2e41"
        />
        <circle
          cx="292.68782"
          cy="225.4797"
          r="28.68469"
          transform="translate(-161.56464 188.64661) rotate(-61.33685)"
          fill="#ffb7b7"
        />
        <path
          d="M319.95312,226.37631H282.08236a2.924,2.924,0,0,1-2.89721-2.55819l-.49042-3.92225a1.75171,1.75171,0,0,0-3.32576-.5235l-2.48264,5.31939a2.931,2.931,0,0,1-2.64572,1.68455H264.4881a2.91919,2.91919,0,0,1-2.90662-3.198l2.26821-23.69207a2.94218,2.94218,0,0,1,1.66859-2.378c17.34363-8.09656,34.93134-8.0863,52.275.0308a2.924,2.924,0,0,1,1.652,2.24112l3.3979,23.66128a2.91891,2.91891,0,0,1-2.89008,3.33488Z"
          transform="translate(-116.01378 -185.5)"
          fill="#2f2e41"
        />
        <polygon
          points="267.719 265.859 266.305 264.445 327.767 202.982 446.875 202.982 506.97 141.647 624.539 141.647 683.855 81.869 959.972 81.869 959.972 83.869 684.688 83.869 625.372 143.647 507.81 143.647 447.715 204.982 328.596 204.982 267.719 265.859"
          fill="#3f3d56"
        />
        <circle cx="508.97244" cy="143" r="37" fill="#fff" />
        <circle cx="684.97244" cy="83" r="10" fill="#cbcbcb" />
        <circle cx="957.97244" cy="83" r="10" fill="#cbcbcb" />
        <circle cx="821.97244" cy="83" r="10" fill="#cbcbcb" />
        <path
          d="M624.98622,366.5a38,38,0,1,1,38-38A38.04307,38.04307,0,0,1,624.98622,366.5Zm0-74a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,624.98622,292.5Z"
          transform="translate(-116.01378 -185.5)"
          fill="#3f3d56"
        />
        <circle
          cx="508.97244"
          cy="143"
          r="26.43632"
          fill="#4580F7"
          class="theme-fill"
        />
        <polygon
          points="506.453 154.16 498.541 143.986 503.142 140.407 506.889 145.224 519.545 131.863 523.777 135.873 506.453 154.16"
          fill="#fff"
        />
        <circle cx="326.97244" cy="204" r="37" fill="#fff" />
        <path
          d="M442.98622,427.5a38,38,0,1,1,38-38A38.04315,38.04315,0,0,1,442.98622,427.5Zm0-74a36,36,0,1,0,36,36A36.0407,36.0407,0,0,0,442.98622,353.5Z"
          transform="translate(-116.01378 -185.5)"
          fill="#3f3d56"
        />
        <circle
          cx="326.97244"
          cy="204"
          r="26.43632"
          fill="#4580F7"
          class="theme-fill"
        />
        <polygon
          points="324.453 215.16 316.541 204.986 321.142 201.407 324.889 206.224 337.545 192.863 341.777 196.873 324.453 215.16"
          fill="#fff"
        />
      </svg>
      <div class="details">
        <p class="title">
          {{ $t("martinelli.process.details") }}
        </p>
        <p><i class="fa fa-check" /> {{ $t("martinelli.process.check1") }}</p>
        <p><i class="fa fa-check" /> {{ $t("martinelli.process.check2") }}</p>
        <p><i class="fa fa-check" /> {{ $t("martinelli.process.check3") }}</p>
        <b-button
          variant="primary"
          :to="'/' + Routes['report'][$i18n.locale]"
          class="mx-3"
          >{{ $t("martinelli.process.reportBtn") }}
          <i class="ml-2 fa fa-arrow-right text-white"
        /></b-button>
      </div>
    </section>
    <section
      v-if="hasDocumentsSection"
      id="leiturasImportantes"
      class="section5"
    >
      <div class="content">
        <h1>
          {{ $t("martinelli.documents.title") }}
          <small>{{ $t("martinelli.documents.titleSmall") }}</small>
        </h1>
        <p>
          {{ $t("martinelli.documents.description") }}
        </p>
      </div>
      <div class="details">
        <div v-for="file in files" :key="file.title" class="file-entry">
          <b-avatar variant="primary" class="position-relative">
            <i v-if="file.icon" :class="file.icon" />
            <template v-else>
              <i
                v-for="icon in file.icons"
                :key="icon.class"
                :class="icon.class"
                :style="icon.style"
              />
            </template>
          </b-avatar>
          <h3>
            {{ file.title }}
            <b-button
              variant="link"
              class="theme-color"
              target="_blank"
              :to="file.url"
              >{{ $t("martinelli.documents.download") }}
              <i class="fa fa-arrow-right"
            /></b-button>
          </h3>
        </div>
      </div>
      <svg
        class="img"
        width="748.974"
        height="457.275"
        viewBox="0 0 748.974 457.275"
      >
        <g id="Group_201" transform="translate(-382.003 -195.455)">
          <g id="Group_200" transform="translate(382.003 195.455)">
            <path
              id="Path_3120-2513"
              d="M695.225,508.82,433.394,576.244a34.622,34.622,0,0,1-42.114-24.866L312.1,243.879a34.622,34.622,0,0,1,24.866-42.114l243.591-62.727L642.9,166.948l77.191,299.757A34.622,34.622,0,0,1,695.225,508.82Z"
              transform="translate(-311.003 -139.037)"
              fill="#f2f2f2"
            />
            <path
              id="Path_3121-2514"
              d="M338.989,210.925a24.655,24.655,0,0,0-17.708,29.99l79.185,307.5a24.655,24.655,0,0,0,29.99,17.708L692.287,498.7a24.655,24.655,0,0,0,17.708-29.99L634,173.595l-54.792-24.529Z"
              transform="translate(-310.548 -138.556)"
              fill="#fff"
            />
            <path
              id="Path_3122-2515"
              d="M629.927,168.5l-40.522,10.435a11.518,11.518,0,0,1-14.026-8.282l-7.707-29.929a.72.72,0,0,1,.989-.837l61.379,27.258a.72.72,0,0,1-.113,1.355Z"
              transform="translate(-298.695 -139)"
              fill="#f2f2f2"
            />
            <path
              id="Path_3123-2516"
              d="M612.519,418.284l-119.208,30.7a5.759,5.759,0,0,1-2.872-11.154l119.208-30.7a5.759,5.759,0,1,1,2.872,11.154Z"
              transform="translate(-302.605 -126.189)"
              fill="#ccc"
            />
            <path
              id="Path_3124-2517"
              d="M640.149,430.592,497.936,467.214a5.759,5.759,0,1,1-2.872-11.154l142.213-36.622a5.759,5.759,0,0,1,2.872,11.154Z"
              transform="translate(-302.384 -125.599)"
              fill="#ccc"
            />
            <circle
              id="Ellipse_44"
              cx="20.355"
              cy="20.355"
              r="20.355"
              transform="translate(121.697 319.055)"
              fill="#4580F7"
              class="theme-fill"
            />
            <path
              id="Path_3125-2518"
              d="M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437Z"
              transform="translate(-307.183 -135.611)"
              fill="#fff"
            />
            <path
              id="Path_3126-2519"
              d="M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437ZM404.563,253.826a15.737,15.737,0,0,0-11.3,19.142l33.178,128.889a15.737,15.737,0,0,0,19.142,11.3L603.9,372.407a15.737,15.737,0,0,0,11.3-19.142L582.025,224.376a15.737,15.737,0,0,0-19.142-11.3Z"
              transform="translate(-307.183 -135.611)"
              fill="#e6e6e6"
            />
            <path
              id="Path_411-2520"
              d="M550.66,252.63l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z"
              transform="translate(-303.514 -133.861)"
              fill="#f2f2f2"
            />
            <path
              id="Path_412-2521"
              d="M554.1,266l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z"
              transform="translate(-303.349 -133.22)"
              fill="#f2f2f2"
            />
            <path
              id="Path_413-2522"
              d="M461.146,298.825,436.761,305.1a3.1,3.1,0,0,1-3.776-2.23L425.577,274.1a3.1,3.1,0,0,1,2.23-3.776l24.385-6.277a3.105,3.105,0,0,1,3.776,2.23l7.408,28.777a3.1,3.1,0,0,1-2.23,3.776Z"
              transform="translate(-305.513 -133.047)"
              fill="#4580F7"
              class="theme-fill"
            />
            <path
              id="Path_414-2523"
              d="M562.854,293.445,440.909,324.835a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
              transform="translate(-304.946 -131.904)"
              fill="#f2f2f2"
            />
            <path
              id="Path_415-2524"
              d="M566.3,306.822,444.353,338.213a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
              transform="translate(-304.781 -131.263)"
              fill="#f2f2f2"
            />
            <path
              id="Path_416-2525"
              d="M569.739,320.192,447.794,351.582a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.379-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
              transform="translate(-304.616 -130.621)"
              fill="#f2f2f2"
            />
            <path
              id="Path_417-2526"
              d="M573.183,333.569,451.237,364.959a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C576.377,329.564,575.513,332.969,573.183,333.569Z"
              transform="translate(-304.45 -129.98)"
              fill="#f2f2f2"
            />
            <path
              id="Path_418-2527"
              d="M576.624,346.939,454.679,378.329a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C579.819,342.934,578.954,346.339,576.624,346.939Z"
              transform="translate(-304.285 -129.339)"
              fill="#f2f2f2"
            />
            <path
              id="Path_395-2528"
              d="M448.363,470.511a2.111,2.111,0,0,1-1.335-.092l-.026-.011-5.545-2.351a2.126,2.126,0,1,1,1.664-3.913l3.593,1.528,4.708-11.076a2.125,2.125,0,0,1,2.787-1.124h0l-.028.072.029-.073a2.127,2.127,0,0,1,1.124,2.788l-5.539,13.023a2.126,2.126,0,0,1-1.431,1.224Z"
              transform="translate(-304.809 -123.966)"
              fill="#fff"
            />
          </g>
          <g id="Group_199" transform="translate(673.007 225.872) rotate(-8)">
            <g id="Group_198" transform="translate(125.896 0) rotate(19)">
              <path
                id="Path_3127-2529"
                d="M304.956,386.7H34.583A34.622,34.622,0,0,1,0,352.114V34.583A34.622,34.622,0,0,1,34.583,0H286.121l53.418,42.577V352.114A34.622,34.622,0,0,1,304.956,386.7Z"
                transform="translate(0 0)"
                fill="#e6e6e6"
              />
              <path
                id="Path_3128-2530"
                d="M24.627,0A24.655,24.655,0,0,0,0,24.627V342.158a24.655,24.655,0,0,0,24.627,24.627H295a24.655,24.655,0,0,0,24.627-24.627V37.418L272.683,0Z"
                transform="translate(9.956 9.956)"
                fill="#fff"
              />
              <path
                id="Path_3129-2531"
                d="M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z"
                transform="translate(123.512 90.767)"
                fill="#4580F7"
                class="theme-fill"
              />
              <path
                id="Path_3130-2532"
                d="M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z"
                transform="translate(123.512 110.204)"
                fill="#4580F7"
                class="theme-fill"
              />
              <path
                id="Path_3131-2533"
                d="M128.852,0H5.758a5.758,5.758,0,1,0,0,11.517H128.852a5.759,5.759,0,0,0,0-11.517Z"
                transform="translate(123.517 177.868)"
                fill="#ccc"
              />
              <path
                id="Path_3132-2534"
                d="M152.609,0H5.758a5.759,5.759,0,1,0,0,11.517h146.85a5.759,5.759,0,1,0,0-11.517Z"
                transform="translate(123.517 197.307)"
                fill="#ccc"
              />
              <path
                id="Path_3133-2535"
                d="M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z"
                transform="translate(123.512 264.975)"
                fill="#ccc"
              />
              <path
                id="Path_3134-2536"
                d="M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z"
                transform="translate(123.512 284.411)"
                fill="#ccc"
              />
              <circle
                id="Ellipse_44-2"
                cx="20.355"
                cy="20.355"
                r="20.355"
                transform="translate(57.655 85.89)"
                fill="#4580F7"
                class="theme-fill"
              />
              <path
                id="Path_395-2-2537"
                d="M6.909,15.481a2.111,2.111,0,0,1-1.27-.422l-.023-.017L.832,11.382A2.126,2.126,0,0,1,3.419,8.008l3.1,2.376L13.839.832A2.125,2.125,0,0,1,16.819.439h0L16.774.5l.047-.063a2.127,2.127,0,0,1,.393,2.98L8.6,14.649a2.126,2.126,0,0,1-1.691.829Z"
                transform="translate(69.085 98.528)"
                fill="#fff"
              />
              <path
                id="Path_3135-2538"
                d="M40.707,20.359A20.354,20.354,0,0,1,20.356,40.721a4.372,4.372,0,0,1-.524-.021A20.353,20.353,0,1,1,40.707,20.359Z"
                transform="translate(59.75 172.987)"
                fill="#4580F7"
                class="theme-fill"
              />
              <circle
                id="Ellipse_44-3"
                cx="20.355"
                cy="20.355"
                r="20.355"
                transform="translate(57.655 260.097)"
                fill="#4580F7"
                class="theme-fill"
              />
              <path
                id="Path_3136-2539"
                d="M53.362,43.143H11.518A11.518,11.518,0,0,1,0,31.625V.72A.72.72,0,0,1,1.167.156l52.642,41.7a.72.72,0,0,1-.447,1.284Z"
                transform="translate(285.137 0.805)"
                fill="#ccc"
              />
            </g>
          </g>
          <path
            id="Path_3140-2540"
            d="M754.518,518.049a9.158,9.158,0,0,1-12.587,3.05L635.078,455.923a9.158,9.158,0,0,1,9.538-15.637l106.852,65.176a9.158,9.158,0,0,1,3.049,12.587Z"
            transform="translate(123.58 101.359)"
            fill="#3f3d56"
          />
          <path
            id="Path_3141-2541"
            d="M688.648,486.5a73.265,73.265,0,1,1-24.4-100.7A73.265,73.265,0,0,1,688.648,486.5ZM579.19,419.73a54.949,54.949,0,1,0,75.524-18.3,54.949,54.949,0,0,0-75.524,18.3Z"
            transform="translate(82.597 67.737)"
            fill="#3f3d56"
          />
          <circle
            id="Ellipse_44-4"
            cx="57.007"
            cy="57.007"
            r="57.007"
            transform="translate(672.542 442.858) rotate(19)"
            fill="#4580F7"
            class="theme-fill"
          />
        </g>
      </svg>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Routes } from "@/i18n";

export default {
  name: "CompanyHome",
  computed: {
    ...mapGetters(["company", "portal", "portalBucket"]),
    logo() {
      return `https://${this.portalBucket}/${this.portal._id}/${this.portal?.logo}`;
    },
    bg1() {
      return `https://${this.portalBucket}/${this.portal._id}/bg1.png`;
    },
    bg1Style() {
      const bg = `url(${this.bg1})`;
      return `background-image: ${bg}`;
    },
    bg2() {
      return `https://${this.portalBucket}/${this.portal._id}/bg2.png`;
    },
    bg2Style() {
      const bg = `url(${this.bg2})`;
      return `background-image: ${bg}`;
    },
    hasDocumentsSection() {
      return Object.keys(this.company.compliance?.files || {}).length > 0;
    },
    files() {
      // const map = {
      //   ethicsConduct: {
      //     title: this.$i18n.t("router.Code of Ethics"),
      //     url: `/download/ethicsConduct`,
      //     icons: [
      //       {
      //         class: "position-absolute fa fa-certificate",
      //         style: "font-size: 1.3rem",
      //       },
      //       {
      //         class: "position-absolute theme-color fa fa-check",
      //         style: "font-size: 0.8rem",
      //       },
      //     ],
      //   },
      //   policy: {
      //     title: this.$i18n.t("router.Compliance"),
      //     url: `/download/policy`,
      //     icon: "fa fa-user-shield",
      //   },
      //   procedures: {
      //     title: this.$i18n.t("router.Channel Policy"),
      //     url: `/download/procedures`,
      //     icons: [
      //       {
      //         class: "position-absolute fa fa-laptop",
      //       },
      //       {
      //         class: "position-absolute fa fa-check",
      //         style: "font-size: 0.6rem",
      //       },
      //     ],
      //   },
      //   committee: {
      //     title: this.$i18n.t("router.Committee"),
      //     url: "/download/committee",
      //     icon: "fa fa-user-tie",
      //   },
      // };
      const entries = [];

      for (const file of this.company.compliance?.files || []) {
        console.log(file);
        entries.push({
          title: file.name,
          url: `/download/${file._id}`,
          icon: "fa fa-file",
        });
      }
      return entries;
    },
    title() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].title
      )
        return portal.languages[lang].title;
      return this.$i18n.t("home.title", [this.company.fantasyName]);
    },
    introductionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].introductionText
      )
        return portal.languages[lang].introductionText;
      return this.$i18n.t("home.introductionText", [this.company.fantasyName]);
    },
    instructionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].instructionText
      )
        return portal.languages[lang].instructionText;
      return this.$i18n.t("home.instructionText", [this.company.fantasyName]);
    },
    phoneServiceText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].phoneServiceText
      )
        return portal.languages[lang].phoneServiceText;

      if (this.company.phoneService && this.company.phoneService.hasService) {
        const phone = this.company.phoneService.phone;
        return this.$i18n.t("home.phoneService", [phone]);
      }
      return "";
    },
  },
  methods: {
    getRoute(path, alt = false) {
      return Routes[`${path}${alt ? "Alt" : ""}`][this.$i18n.locale];
    },
  },
  data() {
    return {
      Routes,
      protocol: "",
    };
  },
};
</script>

<style scoped lang="scss"></style>
